import { Drawer, IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const StyledNavbarContainer = styled.div`
  && {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px;
  }
`

export const StyledNavbarTitle = styled.div`
  && {
    text-align: center;
    font-size: 18px;
    width: 100%;
    font-weight: 600;
    background-color: ${(props) => props.theme.colors.graySemiDark};
    padding: 6px 0px;
  }
`

export const StyledGrid = styled.div`
  && {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 6px;
    border: 1px solid ${(props) => props.theme.colors.grayBorder};
    cursor: pointer;
    color: ${(props) => props.theme.colors.white};
    font-weight: 600;
    font-size: 14px;
    transition: background-color 0.2s;
    background-color: ${(props) => props.theme.colors.darkGray};
    border-radius: 8px;

    &:hover {
      background-color: ${(props) => props.theme.colors.grayLight};
    }

    svg {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`

export const StyledProductsDrawer = styled(Drawer)`
  && {
    z-index: 1200;

    .MuiPaper-root {
      background: ${(props) => props.theme.colors.graySemiDark};
      max-height: 80vh;
      overflow-y: auto;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    }
  }
`

export const StyledDrawerTitle = styled.div`
  && {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${(props) => props.theme.colors.white};
    font-size: 24px;
    font-weight: 700;
    padding: 20px 30px;
    border-bottom: 2px solid ${(props) => props.theme.colors.grayBorder};
    background: ${(props) => props.theme.colors.grayDark};
    position: sticky;
    top: 0;
    z-index: 10;

    span {
      flex: 1;
    }

    svg {
      color: ${(props) => props.theme.colors.white};
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: ${(props) => props.theme.colors.red};
      }
    }
  }
`

export const StyledDrawerContent = styled.div`
  && {
    padding: 0;
    max-width: 100%;
    margin: 0 auto;
    width: 100%;
  }
`

export const StyledGroupItem = styled.div`
  && {
    background-color: ${(props) => props.theme.colors.darkGray};
  }
`

export const StyledListItem = styled(Link)`
  && {
    display: flex;
    align-items: center;
    gap: 12px;
    color: ${(props) => props.theme.colors.white};
    padding: 12px 24px;
    cursor: pointer;
    text-decoration: none;
    transition:
      background-color 0.2s,
      transform 0.1s;
    font-size: 14px;

    svg {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      color: ${(props) => props.theme.colors.white};
      fill: ${(props) => props.theme.colors.white};
    }

    span {
      flex: 1;
      line-height: 1.4;
    }

    &:hover {
      background-color: ${(props) => props.theme.colors.grayLight};
      padding-left: 28px;
    }
  }
`

export const StyledButtonBackToTop = styled(IconButton)`
  && {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: ${(props) => props.theme.colors.red};
    color: ${(props) => props.theme.colors.white};
    z-index: 1000;
    width: 50px;
    height: 50px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    &:hover {
      background: ${(props) => props.theme.colors.lightRed};
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
    }
  }
`
